export const COLORADO_SECTION_ID = "Colorado";
export const CONNECTICUT_SECTION_ID = "Connecticut";
export const DISTRICT_OF_COLUMBIA_SECTION_ID = "District of Columbia";
export const FLORIDA_SECTION_ID = "Florida";
export const ILLINOIS_SECTION_ID = "Illinois";
export const IOWA_SECTION_ID = "Iowa";
export const KANSAS_SECTION_ID = "Kansas";
export const MARYLAND_SECTION_ID = "Maryland";
export const MASSACHUSETTS_SECTION_ID = "Massachusetts";
export const MINNESOTA_SECTION_ID = "Minnesota";
export const OKLAHOMA_SECTION_ID = "Oklahoma";
export const RHODE_ISLAND_SECTION_ID = "Rhode Island";
export const SOUTH_DAKOTA_SECTION_ID = "South Dakota";
export const WASHINGTON_SECTION_ID = "Washington";
